<template>
	<div :class="selectable ? 'choices-selectable' : ''" class="choices">
    <div class="choice-wrapper" :class="innerContainerClass"
         v-if="choiceType === 'multipleChoice' || choiceType === 'multipleAnswers'">
      <div
          v-for="(choice, i) in choices"
          v-bind:key="i"
          :class="getChoiceClass(i)"
          class="choice-container choice-container-multiple-choice"
      >
        <choice
            :class="'choice-' + i"
            :format="choice.format || 'text'"
            :index="i"
            :message="choice.message || choice.text"
            :toggled="activeChoiceIndexes && activeChoiceIndexes.includes(i)"
            :data="{ globalScore: choice.globalScore }"
            :bookmark="getLetter(i)"
            class="choice"
            v-on:click.native="onChoiceClick(i)"
        />
      </div>
    </div>
	</div>
</template>

<script>
	import Choice from './choice'
  import {mapGetters} from 'vuex';

	export default {
		props: {
			selectable: {
				type: Boolean,
				required: false,
				default: false
			},
			choices: {
				type: Array,
				required: true
			},
			value: {},

      instantSelection: {
        type: Boolean,
        required: false,
        default: false
      },

      type: {
        type: String,
        default: 'vertical',
      },

      choiceType: {
        type: String,
        default: 'multipleChoice',
      }
		},
		components: {
			Choice
		},
		data() {
			return {
        activeChoiceIndexes: [],
			}
		},
    watch: {
      value() {
        this.recomputeFromValue();
      },
      choices: {
        deep: true,
        handler() {
          this.resetChoice();
        }
      },
      currentPageIndex() {
        this.resetChoice();
      },
      currentPagePhase() {
        this.resetChoice();
      },
    },
    mounted() {
      this.recomputeFromValue();
      this.resetChoice();
    },
		methods: {
			getLetter(index) {
				switch(index) {
					case 0:
						return 'A';
					case 1:
						return 'B';
					case 2:
						return 'C';
					case 3:
						return 'D';
					case 4:
						return 'E';
					case 5:
						return 'F';
				}
			},

      recomputeFromValue() {
        if (this.value instanceof Array) {
          this.activeChoiceIndexes = this.value;
        } else {
          this.activeChoiceIndexes = [this.value];
        }

        console.log('recomputeFromValue', this.value, this.activeChoiceIndexes);
      },
      onChoiceClick(clickedChoiceIndex) {
        if (!this.selectable) {
          return
        }

        if (this.choiceType === 'likertScale' || this.choiceType === 'multipleChoice') {
          // Only one result!
          this.activeChoiceIndexes = [clickedChoiceIndex];
        } else if (this.choiceType === 'multipleAnswers') {
          // Toggle it
          if (this.activeChoiceIndexes.includes(clickedChoiceIndex)) {
            // Toggle it off
            this.activeChoiceIndexes = this.activeChoiceIndexes.filter(item => item !== clickedChoiceIndex)
          } else {
            // Toggle it on
            this.activeChoiceIndexes.push(clickedChoiceIndex);
          }
        }

        this.$emit('value', this.activeChoiceIndexes)

        if (this.instantSelection) {
          this.$emit('submit', this.activeChoiceIndexes);
        }
      },
      getChoiceClass(i) {
        let classes = [];

        if (this.activeChoiceIndexes.includes(i)) {
          classes.push('choice-container-active');
        }

        if (this.type === 'horizontal') {
          classes.push('col-3');
        } else {
          classes.push('row');
        }

        return classes;
      },
      resetChoice() {
        this.activeChoiceIndexes = this.choiceType === 'likertScale' ? [0] : [];
        this.$emit('value', this.activeChoiceIndexes)

        console.log('resetChoice', this.activeChoiceIndexes);
      },
		},
    computed: {
      ...mapGetters({
        currentPageIndex: 'getCurrentPageIndex',
        currentPagePhase: 'getCurrentPagePhase'
      }),
      containerClass() {
        let classes = [];

        if (this.selectable) {
          classes.push('choices-selectable');
        }

        if (this.type === 'horizontal') {
          classes.push('row');
          classes.push('justify-content-left');
        } else {
          classes.push('container');
        }
        return classes;
      },
      innerContainerClass() {
        let classes = [];

        if (this.selectable) {
          classes.push('choices-selectable');
        }

        if (this.type === 'horizontal') {
          classes.push('row');
          classes.push('justify-content-left');
        }

        classes.push('choice-wrapper-' + this.choiceType);

        return classes;
      }
    }
	}
</script>

<style lang="less">
	@import "~@less/variables.less";

	.teacher-container {
		.choices {
			margin: 0 auto;
		}
	}

	.choices {
		margin-top: 20px;

		&.choices-selectable {
			.choice {
				cursor: pointer;
				&:hover {
					border-left: 6px solid;
				}
				&-0:hover {
					border-color: @choice-color-1;
				}
				&-1:hover {
					border-color: @choice-color-2;
				}
				&-2:hover {
					border-color: @choice-color-3;
				}
				&-3:hover {
					border-color: @choice-color-4;
				}
				&-4:hover {
					border-color: @choice-color-5;
				}
				&-5:hover {
					border-color: @choice-color-6;
				}
			}
		}

		.choice-container {
			overflow: hidden;
			position: relative;
			margin-bottom: 10px;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			justify-content: flex-start;
			align-items: flex-start;
			align-content: stretch;

			&.choice-container-active {
				.choice {
					outline: 4px solid black;
					outline-offset: -4px;
				}
			}
		}

		.choice {
			display: flex;
			width: 100%;
			background-color: @whiteish;

			.bookmark {
				margin: 10px;
				background-color: @grey-light;
			}

			.content-container {
				display: flex;
				align-self: stretch;
				flex: 1 1 auto;
				padding: 10px 10px 13px 10px;

				.content {
					margin: 0 auto;
				}
			}

			// choice-INDEX (0 indexed)
			&.choice-0 .bookmark {
				background: @choice-color-1;
				color: white;
			}

			&.choice-1 .bookmark {
				background: @choice-color-2;
				color: white;
			}

			&.choice-2 .bookmark {
				background: @choice-color-3;
				color: white;
			}

			&.choice-3 .bookmark {
				background: @choice-color-4;
				color: white;
			}

			&.choice-4 .bookmark {
				background: @choice-color-5;
				color: white;
			}

			&.choice-5 .bookmark {
				background: @choice-color-6;
				color: white;
			}
		}
	}
</style>
